import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const useLabelStyles = createUseStyles({
  labelWrapper: {
    fontWeight: 'bold',
    fontSize: 12,
    margin: '0.5rem 0',
    color: colors.gray600
  }
})

export { useLabelStyles }
